











import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power1,
    Power2,
    TimelineMax,
} from 'gsap';
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "HomeFullimg",
})
export default class HomeFullimg extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    Tlm: any | null = null;
    @Prop() public controller!: any | null;
    @Prop() public controller1!: any | null;
    public updatePercentage() {
        this.Tlm.progress();
    }
    public scrollAnim() {
        const tl1 = new TimelineMax({
            onUpdate: () => {
                this.updatePercentage();
            }
        })
        tl1.to('.cbanner-inner .text-animtion', 1, {
            opacity: .9,
            transform: 'translateY(-100%)',
            force3D: true,
            rotation: 0.01,
            z: 0.01,
            autoRound: false,
            ease: Power1.easeOut
        })
        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
                triggerElement: ".cbanner-inner",
                triggerHook: "onLeave",
                duration: "100%"
            })
            .setTween(tl1)
            .addTo(controller);
        this.Tlm = tl1;
    }
    public mounted() {
        this.scrollAnim();
    }
}
